<template>
  <div id="unit">
    <!-- 共通header -->
    <dd-header />
    <!-- 上部タブ -->
    <span id="left_content">
      <nav id="main_nav">
        <ul class="container">
          <li class=" choosing_tab main_tab">
            <h2>ユニット登録</h2>
          </li>
        </ul>
      </nav>
      <div class="container_main">
        <!-- 左部サイドバー -->
        <div class="sidebar_left">
          <nav @click="closeDetail">
            <section>
              <span class="menu_head">ユニットショップ</span>
              <ul>
                <li><a @click="getOpenUnitList(pageNo, dataCount)">・ユニット検索</a></li>
              </ul>
            </section>
            <section>
              <span class="menu_head">登録ユニット</span>
              <ul>
                <li><a @click="getUnitList(pageNo, dataCount)">・ユニットリスト</a></li>
                <li><a href="#">・ユニット登録依頼<br>&ensp;(cooming soon)</a></li>
                <li><a href="#">・オリジナルユニット<br>&ensp;(cooming soon)</a></li>
              </ul>
            </section>
          </nav>
        </div>
        <main><!--  メインコンテンツ  -->
          <!-- <dd-slideTop
            v-show= showTop
          /> -->
          <!-- 検索バー -->
          <div class="search">
            <form id="form_search" action="自分のサイトURL" v-if="!isDel">
              <input id="searchbox" name="s" type="text" :style="searchBox" placeholder="キーワードを入力してください" @click.prevent="search" alt="検索"/>
            </form>
          </div>
          <!-- ローディングモーダル -->
          <dd-loading-modal ref="loadingModalRef" />
          <!-- ユニット一覧 -->
          <dd-unit-List
            :unitList="isDel ? unitList : openUnitList"
            :isOpen="!isDel"
            :pageNo="pageNo"
            :dataCount="dataCount"
            :totalCount="totalCount"
            :selectUnitNo="selectUnitNo"
            @getUnitList="getUnitList"
            @getOpenUnitList="getOpenUnitList"
            @getDetailData="getDetailData"
            @selectedUnit="selectedUnit"
          />
        </main>
      </div>
    </span>
    <span id="right_content">
      <!-- ユニット詳細情報 -->
      <dd-unit-detail
          ref="unitDetailRef"
          :detailData="detailData"
          :isOpen="!isDel"
          @getFileList="getFileList"
      />
    </span>
    <dd-footer />
  </div>
</template>
<script>
// Libraries
import axios from 'axios'
// Modeles
import {API_URL} from '../constants/App'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
import Header from '../components/common/Header'
import Footer from '../components/common/Footer'
import SlideTop from '../components/unit/SlideTop'
import UnitDetail from '../components/unit/UnitDetail'
import UnitList from '../components/unit/UnitList'
import LoadingModal from '../components/common/LoadingModal'
export default {
  name: 'Unit',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-slideTop': SlideTop,
    'dd-unit-detail': UnitDetail,
    'dd-unit-List': UnitList,
    'dd-loading-modal': LoadingModal
  },
  methods: {
    /** ユニットリスト取得(emit用共通化処理) */
    getFileList: function (isOpen) {
      if (isOpen) {
        this.getOpenUnitList(this.pageNo, this.dataCount)
      } else {
        this.getUnitList(this.pageNo, this.dataCount)
      }
    },
    /** 公開ファイルデータ取得 */
    getOpenUnitList: function (param1, param2) {
      if (this.isDel !== false) {
        param1 = 1
        this.pageNo = param1
      } else {
        this.pageNo = param1
      }
      this.isDel = false
      axios.get(API_URL.UNIT + '/open/' + param1 + '/' + param2)
        .then(response => {
          this.openUnitList = response.data.data
          this.getTotalCount('open')
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** ファイルデータ取得 */
    getUnitList: function (param1, param2) {
      if (this.isDel !== true) {
        param1 = 1
        this.pageNo = param1
      } else {
        this.pageNo = param1
      }
      this.isDel = true
      if (param1 == null && param2 == null) {
        param1 = this.pageNo
        param2 = this.dataCount
      }
      axios.get(API_URL.UNIT + '/list/' + param1 + '/' + param2)
        .then(response => {
          this.unitList = response.data.data
          // 全データ数取得
          this.getTotalCount('list')
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** 合計件数取得 */
    getTotalCount: function (param1) {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(API_URL.UNIT + '/total/' + param1)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.totalCount = response.data.data
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 詳細情報取得 */
    getDetailData: function (param) {
      if (this.isDel === false) {
        axios.get(API_URL.UNIT + '/open/' + param)
          .then(response => {
            this.detailData = response.data.data
            this.$refs.unitDetailRef.showDetail(true)
          }).catch(error => {
            Api.handleError(error)
          })
      } else {
        axios.get(API_URL.UNIT + '/' + param)
          .then(response => {
            this.detailData = response.data.data
            this.$refs.unitDetailRef.showDetail(true)
          }).catch(error => {
            Api.handleError(error)
          })
      }
    },
    /** ユニット検索 */
    search: function (event) {
      alert('未実装')
    },
    closeDetail: function () {
      this.$refs.unitDetailRef.showDetail(false)
    },
    selectedUnit: function (selectNo) {
      this.selectUnitNo = selectNo
    }
  },
  data () {
    return {
      /** 公開ファイルデータリスト */
      openUnitList: [],
      /** 詳細情報 */
      detailData: {},
      /** ファイルデータリスト */
      unitList: [],
      /** 削除機能 */
      isDel: false,
      /** ページ番号 */
      pageNo: 1,
      /** 1ページごとの表示件数 */
      dataCount: 8,
      /** 合計件数 */
      totalCount: 0,
      /** 現在選択中のユニット番号 */
      selectUnitNo: -1,
      /** 検索フォームのスタイル */
      searchBox: {
        backgroundImage: 'url(' + App.getDarosResource('component/unit/ic_search.svg') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right center',
        backgroundSize: 'contain'
      }
    }
  },
  created: function () {
    this.getOpenUnitList(this.pageNo, this.dataCount)
  }
}
</script>
<style src="../css/unit/unit.scss"  lang="scss" scoped></style>
<style lang="scss" scoped>
main {
  width: calc(100% - 271px);
  min-width: 625px;
  height: 100%;
  min-height: 660px;
  margin: 0px 5px 0px 0px;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  border-radius: 0px 5px 5px 0px;
  background: #eee;
  padding-left:20px;
  div {
    margin: 0px 5px 0px 5px;
  }
}
a{
  color: #000 !important;
}
a:hover {
  color: #ff4500 !important;
}
.menu_head{
  letter-spacing: 0.01em;
  font-size: 13px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/Unit.vue